import { isEmpty } from "lodash";
import CardDiv from "modules/common/card-div/CardDiv";
import PaginationDiv from "modules/pagination/PaginationDiv";
import AddComboProduct from "modules/product_mapping/AddComboProduct";
import AddNewProduct from "modules/product_mapping/AddNewProduct";
import ProductTable from "modules/product_mapping/ProductTable";
import { useProductMappingStore } from "modules/product_mapping/store";
import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";

function ProductMapping() {
  const { productsData, productsLoading, fetchProductsData } =
    useProductMappingStore();
  const [page, newPage] = useState(1);
  const [filterData, setFilter] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [sortedData, setSortedData] = useState([]);
  const [modalProductShow, setModalProductShow] = useState(false);
  const [modalComboShow, setModalComboShow] = useState(false);

  useEffect(() => {
    fetchProductsData();
  }, []);

  useEffect(() => {
    if (isEmpty(productsData)) setSortedData([]);
    else {
      const ndata = productsData.map((row) => ({
        key: row?.id,
        is_direct_shipping: row?.is_direct_shipping,
        medicine_name: row?.medicine?.display_name,
        medicine_type: row?.medicine?.type,
        product_id: row?.product_id,
        price: row?.product_price,
        principalId: row?.product_principal_id,
      }));
      setSortedData(ndata);
    }
  }, [productsData]);

  const handleCombo = () => {
    setModalComboShow(true);
  };

  const handleProduct = () => {
    setModalProductShow(true);
  };


  useEffect(() => {
    async function calculate() {
      const numOfSubarrays = Math.max(
        Math.ceil((sortedData?.length || 0) / 10),
        0
      );

      const paginationArray = sortedData
        ? Array.from({ length: numOfSubarrays }, (_, index) => {
            const start = index * 10;
            const end = start + 10;
            return sortedData?.slice(start, end);
          })
        : [];
      setPageCount(Math.min(Math.ceil((sortedData?.length || 0) / 10), 100));
      setFilter(paginationArray[page - 1]);
    }
    calculate();
  }, [sortedData, page]);

  return (
    <div>
      <CardDiv
        title={
          <div className="d-flex justify-content-between">
            <div className="fs-2 fw-bold">Products Mapping</div>
            <div className="d-flex gap-3">
              <Button onClick={handleCombo}> Add New Combo </Button>
              <Button onClick={handleProduct}> Add New Product </Button>
            </div>
          </div>
        }
        component={
          <>
            <ProductTable prodData={filterData} isLoading={productsLoading} />
            <PaginationDiv
              newPage={newPage}
              paginationData={{
                pageCount: pageCount || 1,
                page: page,
              }}
            />
          </>
        }
      />
      <AddNewProduct
        modalProductShow={modalProductShow}
        setModalProductShow={setModalProductShow}
      />
      <AddComboProduct
        modalComboShow={modalComboShow}
        setModalComboShow={setModalComboShow}
      />
    </div>
  );
}

export default ProductMapping;
